module.exports = __webpack_public_path__ + "static/img/question4-5.72deeeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-5.png
// module id = ee86
// module chunks = 1